import { SendEnrollmentQuotaInput } from '../../lib/types/models/enrollment/enrollment-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendEnrollmentQuotaEmail({ id, ...rest }: IdInput<SendEnrollmentQuotaInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendEnrollmentQuotaEmail.url, { id }))
    .post<never, SendEnrollmentQuotaInput>(rest)
}

export function sendEnrollmentPropositionsEmail({
  id,
  ...rest
}: IdInput<SendEnrollmentQuotaInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendEnrollmentPropositionsEmail.url, { id }))
    .post<never, SendEnrollmentQuotaInput>(rest)
}
